var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DevScreen = function (_a) {
    var title = _a.title;
    return (_jsx("div", __assign({ className: "flex flex-1 items-center justify-center" }, { children: _jsxs("div", __assign({ className: "flex size-[400px] flex-col items-center justify-center gap-[20px] rounded-lg border-0 border-r-8 bg-background-secondary" }, { children: [_jsx("p", __assign({ className: "truncate text-lg font-semibold leading-6 tracking-wide text-[#14181F]" }, { children: title })), _jsx("p", __assign({ className: "text-lg font-semibold leading-6 tracking-wide text-[#14181F]" }, { children: "\u0412 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435..." }))] })) })));
};
